const compareSidebarController: ReturnType<typeof useModal> = useModal();

export const useProductCompareSidebarController = () => {
  return {
    ...compareSidebarController,
  };
};
